import { NgModule } from '@angular/core';
import { AgencyBrandingComponent } from './agency-branding.component';

@NgModule({
  imports: [AgencyBrandingComponent],
  exports: [AgencyBrandingComponent],
})
export class AgencyBrandingModule {}
